import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { UseCategory, useCheckProjectMutation } from '../../actions/homeAction';
import textWeight from '../../utils/textWeight';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const { TextWeight } = textWeight();
  const serviceId = useSelector((state) => state.app.serviceId.serviceId);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      projectName: '',
    },
  });
  const {
    data: services,
    isLoading,
    isError,
    error,
  } = UseCategory(serviceId, currentPage, 12);
  useEffect(() => {
    const newTotalItems = services?.pagination?.totalItems;
    if (newTotalItems && newTotalItems !== totalItems) {
      setTotalItems(newTotalItems);
    }
    if (services?.data?.length === 0 && currentPage > 1) {
      setCurrentPage(1);
    }
  }, [services, totalItems, currentPage]);

  const checkProjectNameMutation = useCheckProjectMutation(
    navigate,
    setLoadingToapi
  );

  const onSubmit = (data) => {
    setLoadingToapi(true);
    checkProjectNameMutation.mutate({
      name: data.projectName,
    });
    const updatedCategoryData = {
      ...data,
      categoryId: selectedCategoryId,
    };
    dispatch({
      type: 'UPDATE_CATEGORY_DATA',
      payload: { categoryData: updatedCategoryData },
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(onSubmit)(e);
  };

  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const itemsPerPage = 12;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  return {
    handleFormSubmit,
    navigate,
    register,
    setValue,
    errors,
    isLoading,
    services,
    selectedCategoryId,
    setSelectedCategoryId,
    loadingToapi,
    TextWeight,
    totalItems,
    currentPage,
    totalPages,
    handlePageChange,
  };
};
